// extracted by mini-css-extract-plugin
module.exports = {"snippetWrapper":"installDocs_snippetWrapper_I4c0jdE","codeCopy":"installDocs_codeCopy_L3i2TjB","snippet":"installDocs_snippet_31NCOLz"};